// Redux/Reducers/RoleReducer.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

/* ---------------- FETCH ROLES ---------------- */
export const fetchRoles = createAsyncThunk(
  "roles/fetch",
  async ({ page = 1, limit = 10, search = "" }) => {
    const res = await axiosInstance.get("/api/admin/roles", {
      params: { page, limit, search }
    });
    return res.data;
  }
);

/* ---------------- CREATE ROLE ---------------- */
export const createRole = createAsyncThunk(
  "roles/create",
  async (payload) => {
    const res = await axiosInstance.post("/api/admin/roles", payload);
    return res.data;
  }
);

/* ---------------- UPDATE ROLE ---------------- */
export const updateRole = createAsyncThunk(
  "roles/update",
  async ({ id, payload }) => {
    const res = await axiosInstance.put(`/api/admin/roles/${id}`, payload);
    return res.data;
  }
);

/* ---------------- DELETE ROLE ---------------- */
export const deleteRole = createAsyncThunk(
  "roles/delete",
  async (id) => {
    await axiosInstance.delete(`/api/admin/roles/${id}`);
    return id;
  }
);

const RoleReducer = createSlice({
  name: "roles",
  initialState: {
    roles: [],
    pagination: {},
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchRoles.rejected, (state) => {
        state.loading = false;
      });
  }
});

export default RoleReducer.reducer;
